import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../components/SearchForm/components/Fields/components/Container.js';
import { Layout } from '../../../../components/SearchForm/components/Fields/components/Layout.js';
export const Fields = ({
  submitButton,
  gridTemplate,
  layout,
  orientation,
  children
}) => _jsxs(Container, {
  direction: orientation === 'horizontal' ? 'row' : 'column',
  spacing: orientation === 'horizontal' ? 'none' : 'medium',
  padding: layout === 'sidebar' ? '16px' : undefined,
  children: [_jsx(Layout, {
    orientation: orientation,
    layout: layout,
    gridTemplate: gridTemplate,
    hasSubmitButton: submitButton !== null,
    children: children
  }), submitButton]
});